@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../../constants/spacing.module.less';

.product-locations {
  padding: @space-16;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

  .product-locations-checkbox {
    flex: 50%;
    margin-bottom: 10px;
  }
}
